/**
 * 머리의 **국가 조건 → 상품 색인의 지역 축**(`region`).
 *
 * 🔑 상품 색인에는 국가 필드가 없다. 대신 **판매몰이 곧 나라**다 — 아마존만 미국이고
 *   나머지(올리브영·화해·무신사·카카오선물하기)는 전부 한국이다. 서버의 `OVERSEAS_SOURCES`
 *   가 그 갈래의 정본이고, 이 함수는 화면의 국가 코드를 그 갈래에 얹기만 한다.
 * ⚠️ **판매몰이 있는 나라는 둘뿐**이다. 일본·베트남 같은 나라를 고르면 걸 축이 없어
 *   `applies` 가 거짓이 되고, 화면은 「여기 안 걸립니다」를 적어야 한다 — 조용히 전부 보이면 거짓말이다.
 */

/** 한국·미국이 아닌 나라는 판매몰이 없다 — 걸 수 있는 나라 둘 */
const KR = 'KR';
const US = 'US';

export type BrandHubProductRegion = {
  /** 상품 조회에 실을 값 — 빈 문자열이면 안 건다 */
  region: 'domestic' | 'overseas' | '';
  /** 머리의 국가 조건이 **지켜졌나** — 거짓이면 화면이 못 걸었다고 적는다 */
  applies: boolean;
};

/**
 * @param countries 머리에 걸린 국가 코드들 — 비어 있으면 「전체」
 * @returns 실을 `region` 과, 그 조건이 지켜졌는지
 */
export function brandHubProductRegion(countries: readonly string[]): BrandHubProductRegion {
  if (countries.length === 0) return { region: '', applies: true };

  const kr = countries.includes(KR);
  const us = countries.includes(US);

  // 둘 다 골랐으면 판매몰 전부가 그 둘이라 좁힐 것이 없다 — 안 걸어도 조건이 지켜진다
  if (kr && us) return { region: '', applies: true };
  if (kr) return { region: 'domestic', applies: true };
  if (us) return { region: 'overseas', applies: true };

  // 판매몰이 없는 나라만 골랐다 — 걸 축이 없다
  return { region: '', applies: false };
}
